import eventCredentialStore from '@store/event-credential-store.ts';
import eventStatsStore from '@store/event-stats-store.ts';

export async function EventCredentialsLoader() {
	void eventStatsStore.getEventStats();
	await eventCredentialStore.getEventCredentials();
	return 'ok';
}
